import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    shouldDisplayInvoiceList: false,
    shouldDisplaySingleInvoice: false,
    shouldDisplayMainUtilityView: true,
    isTransactionSuccessfullyStarted : false,
    isTransactionSuccessfullyCompleted: false,
    transactionId: '',
    localCode: '',
    invoiceList: [],
    isConfirmationDialogOpen: false,
    singleInvoice: {},
    isLoading: false
};

export const taksatSlice = createSlice({
    name: 'taksat',
    initialState,
    reducers:{
        displayInvoiceList : (state) => {
            state.shouldDisplayInvoiceList = true
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayMainUtilityView = false
        },
        displaySingleInvoice : (state) => {
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = false
        },
        displayMainUtilityView : (state) => 
        {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        changeConfirmationDialogState: (state) =>
        {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        resetTaksatSlice : () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'DPTTV/GetTaxesTiranaByNuis' || action.payload.endpoint === 'DPTTV/GetTaxesTiranaByName')
                {   
                    state.localCode = action.payload.response.subject.localCode
                    state.invoiceList = action.payload.response.obligations.map(obligation => { 
                        return {displayInfo: { Viti: obligation.year, Vlera: obligation.differences}, detailedInfo: {'Detajet e fatures': obligation.denomination, 'Adresa': obligation.localUnit, 'Kodi': obligation.obligationCode, 'Viti': obligation.year, 'Numri i llogarise': obligation.accountCode, 'Vlera e kamates': obligation.fee + ' Leke', 'Zbritja e perfituar': obligation.differences + ' Leke' }}
                    })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false   
                }
                else if(action.payload.endpoint === 'DPTTV/StartTransactionTaxesTirana')
                {         
                    state.isTransactionSuccessfullyStarted = true
                    const transactionSummary = action.payload.response.transactionsSummary
                    state.transactionId = action.payload.response.transID
                    state.singleInvoice = {
                        "Nr. i taksave": transactionSummary.NoOfTrans,
                        "Komision takse": transactionSummary.FeePerTrans,
                        "Komision total": transactionSummary.TotalFee,
                        "Vlera": transactionSummary.NetAmount,
                        "Vlera Totale": transactionSummary.GrossAmount,
                        "Info": transactionSummary.info
                    }
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplaySingleInvoice = true
                    state.shouldDisplayMainUtilityView = false     
                }
                else if(action.payload.endpoint === 'DPTTV/ConfirmTransactionTaxesTirana')
                {         
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplayMainUtilityView = true
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplaySingleInvoice = false     
                }
                
            })
    },
})
export const { displayInvoiceList, displaySingleInvoice, displayMainUtilityView, resetTaksatSlice, changeConfirmationDialogState } = taksatSlice.actions;

export const selectTaksatState = (state) => state.taksat;

export default taksatSlice.reducer;

